import { useMemo, useState, useRef, useEffect } from 'react';
import { useLanguage } from '@shared/contexts/LanguageContext';

export function buildNameOptions({ name, dharma, temple }) {
  const opts = [];
  const t = temple?.trim() && temple.trim() !== '無' ? temple.trim() : '';
  const n = name?.trim() || '';
  const d = dharma?.trim() || '';
  if (n) opts.push({ value: n, label: n });
  if (d) opts.push({ value: d, label: d });
  if (t && n) opts.push({ value: `${t}・${n}`, label: `${t}・${n}` });
  if (t && d) opts.push({ value: `${t}・${d}`, label: `${t}・${d}` });
  if (d && n) opts.push({ value: `${d}・${n}`, label: `${d}・${n}` });
  return opts;
}

export function useNameOptions({ name, dharma, temple }) {
  return useMemo(() => buildNameOptions({ name, dharma, temple }), [name, dharma, temple]);
}

export default function CommenterNameSelect({ value, options, onChange }) {
  const { t, currentLanguage } = useLanguage();
  const isEn = currentLanguage.code === 'en';
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  if (!options || options.length === 0) return null;

  const idx = options.findIndex(o => o.value === value);
  const current = idx >= 0 ? options[idx] : options[0];

  return (
    <div className="relative inline-flex items-center gap-1.5" ref={ref}>
      <span className="text-xs text-[--color-text-sub]">{t('commenter-name.prefix')}</span>

      <button
        type="button"
        onClick={() => options.length > 1 && setOpen(o => !o)}
        className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg border transition-colors ${options.length > 1 ? 'border-[#D5C8B5] bg-white hover:bg-[#F5EFE6] hover:border-[--color-primary] cursor-pointer' : 'border-transparent cursor-default'}`}
      >
        <span className="text-xs font-semibold text-[--color-primary]">{current.label}</span>
        {options.length > 1 && (
          <span className="material-symbols-outlined text-[--color-text-sub]" style={{ fontSize: '14px' }}>unfold_more</span>
        )}
      </button>

      {!isEn && t('commenter-name.suffix') && <span className="text-xs text-[--color-text-sub]">{t('commenter-name.suffix')}</span>}
      {/* {options.length > 1 && (
        <span className="text-xs text-[--color-text-sub]/60">（點選「姓名」可切換格式）</span>
      )} */}

      {open && (
        <div className="absolute left-0 bottom-full mb-1.5 bg-white rounded-xl shadow-lg border border-[#E8DCC8] py-1 z-20 min-w-[130px]">
          {options.map(opt => (
            <button
              key={opt.value}
              type="button"
              onClick={() => { onChange(opt.value); setOpen(false); }}
              className={`w-full text-left px-4 py-2 text-xs transition-colors cursor-pointer ${opt.value === value
                  ? 'text-[--color-primary] font-semibold bg-[#FAF7F3]'
                  : 'text-[--color-text-main] hover:bg-[#FAF7F3]'
                }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
